import { useQuery } from '@tanstack/react-query';

import { apiGetContactRelatedContacts } from 'api/acturis/client-center';

import type { ActurisRelatedContact } from 'api/acturis/client-center';

export const CLIENT_CENTER_CUSTOMER_RELATED_CONTACTS_KEY =
  'client-center-customer-related-contacts';

const EMPTY_RELATED_CONTACTS: ActurisRelatedContact[] = [];

export const useClientCenterCustomerRelatedContacts = (customerId: string) => {
  const { data, isLoading, error } = useQuery<ActurisRelatedContact[]>({
    queryKey: [CLIENT_CENTER_CUSTOMER_RELATED_CONTACTS_KEY, customerId],
    queryFn: () => apiGetContactRelatedContacts(customerId),
    enabled: Boolean(customerId),
    staleTime: 30 * 1000,
    retry: false,
  });

  return {
    relatedContacts: data ?? EMPTY_RELATED_CONTACTS,
    isLoading,
    error,
  };
};
